(($, window) => {

    class BLVCPublicAjaxAction {
        static post(action, data) {
            return $.post(BLVC_PUBLIC_DATA.AJAX_URL,
                {
                    _ajax_nonce: BLVC_PUBLIC_DATA.NONCE,
                    action: 'blvc_action',
                    blvc_action: action,
                    ...data
                },
                'json'
            );
        }
    }

    window.BLVCPublicAjaxAction = BLVCPublicAjaxAction;

})(jQuery, window);
